import { bindable, bindingMode, containerless } from 'aurelia-framework';
import SearchOnlyVMBase from 'Lib/Fs.SmartClient.Client/SearchOnlyVMBase';
import CommonSearchVMBase from 'Lib/Fs.SmartClient.Client/CommonSearchVMBase';

export class FsGridHeaderCustomElement {
    @bindable DataContext: CommonSearchVMBase;
    @bindable SortingName: string;
    @bindable DisplayName: string;
    @bindable TranslateKey: string;

    bind(bindingContext: any, overrideContext: any) {
        if (this.DataContext == null) {
            this.DataContext = bindingContext;
        }
    }
}